import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {loadingMessage} from "@Xpresso/loaders/loading-message";

import {Layout} from "../../../../layout/layout";

export const loadTemplateOptions = ({sku, next}) => cs(
    consumeContext("templateOptionsCache"),
    ["template", ({templateOptionsCache}, next) => templateOptionsCache.load({
        key: sku,
        retainOutdatedValue: true,
        next,
    })],
    ({template}) => template.loading ? (
        <Layout className="customize-layout-95r" active={"product-options"}>
            <div className="product-options-step-6rz">
                {loadingMessage({message:"Loading Options...",progress:80})}
            </div>
        </Layout>
    ) : !template.value ? (
        <Layout className="customize-layout-95r" active={"product-options"}>
            <div className="product-options-step-6rz">
                <div className="center">
                    There was an error loading the template options.<br/>
                    Please go back and try again.<br/>
                    If the issue persists please contact us.
                </div>
            </div>
        </Layout>
    ) : next(template.value),
);
